import React, { useState } from 'react';
import { Bell, X, Loader2 } from 'lucide-react';
import { useNotifications } from '../../../context/NotificationContext';
import { needsHomeScreen, isSnoozed, snooze, CHAT_NUDGE_KEY } from '../../../lib/pushPrompt';
import { InstallGuide } from '../../InstallGuide';

// Dismissible strip inside the chat for members without push enabled
export const PushNudge = () => {
  const { permission, supported, isEnabled, enableNotifications, loading, restoring } = useNotifications();
  const [hidden, setHidden] = useState(() => isSnoozed(CHAT_NUDGE_KEY));
  const [guideOpen, setGuideOpen] = useState(false);
  const homeScreen = needsHomeScreen();
  if (hidden || isEnabled || restoring || permission === 'denied' || permission === 'granted' || (!supported && !homeScreen)) return null;
  const dismiss = () => { snooze(CHAT_NUDGE_KEY); setHidden(true); };
  return (
    <div className="flex items-center gap-2 px-3 py-1.5 bg-amber-950/30 border-t border-amber-900/40 text-[11px] font-typewriter text-amber-300/90" data-testid="chat-push-nudge">
      <Bell className="w-3.5 h-3.5 text-amber-500 flex-shrink-0" />
      <span className="flex-1 truncate">
        {homeScreen ? 'On iPhone, add Deadline to your Home Screen to get chat alerts.' : "Turn on notifications so you don't miss replies and mentions."}
      </span>
      {homeScreen ? (
        <button onClick={() => setGuideOpen(true)} className="px-2 py-0.5 rounded bg-amber-600 hover:bg-amber-500 text-black font-headline tracking-wider" data-testid="chat-push-nudge-guide">SHOW ME</button>
      ) : (
        <button onClick={async () => { if (await enableNotifications()) setHidden(true); }} disabled={loading} className="px-2 py-0.5 rounded bg-amber-600 hover:bg-amber-500 text-black font-headline tracking-wider disabled:opacity-60 flex items-center gap-1" data-testid="chat-push-nudge-enable">
          {loading && <Loader2 className="w-3 h-3 animate-spin" />}TURN ON
        </button>
      )}
      <button onClick={dismiss} className="text-zinc-500 hover:text-zinc-200" title="Hide for now" data-testid="chat-push-nudge-dismiss"><X className="w-3.5 h-3.5" /></button>
      <InstallGuide open={guideOpen} onClose={() => setGuideOpen(false)} />
    </div>
  );
};

export default PushNudge;
